import { getDcaPoolContractAddr } from "../config/resolver";
import { getTokenAddress } from "../config/tokens";
import { getCFAv1ForwarderContract } from "./sf";

function computeFlowrate(length, amount) {
  const dayInSeconds = 86400; // 24 * 60 * 60

  let flowRateInEth;
  if (length === 0) {
    // length == 0 => forever, so amount is daily
    flowRateInEth = amount.div(dayInSeconds);
  } else if (length > 0) {
    // length > 0 => rolling days, so amount is total
    flowRateInEth = amount.div(length).div(dayInSeconds);
  } else {
    throw Error("this should never happen");
  }

  return flowRateInEth;
}

function calculateAmountPerHour(length, amount) {
  let amountPerHour;

  if (length === 0) {
    // length == 0 => forever, so amount is daily
    amountPerHour = amount.div(24);
  } else if (length > 0) {
    // length > 0 => rolling days, so amount is total
    amountPerHour = amount.div(length).div(24);
  } else {
    throw Error("this should never happen");
  }

  return amountPerHour;
}

function calculateEscrowAmount(length, amount) {
  let amountPerHour = calculateAmountPerHour(length, amount);

  let escrowHours = 4; // TODO: if testnet == 1, else == 4
  const requiredEscrow = amountPerHour.mul(escrowHours);

  return requiredEscrow;
}

function calculateDailyAmount(length, amount) {
  // do not reuse calculateAmountPerHour because of precision loss
  let dailyAmout;

  if (length === 0) {
    // length == 0 => forever, so amount is daily
    dailyAmout = amount;
  } else if (length > 0) {
    // length > 0 => rolling days, so amount is total
    dailyAmout = amount.div(length);
  } else {
    throw Error("this should never happen");
  }

  return dailyAmout;
}

async function startDCA(provider, chainId, signer, account, sourceToken, targetToken, length, amount) {
  console.log("[dca] creating the DCA flow", sourceToken, targetToken, length, amount.toString());

  const flowRateInWei = computeFlowrate(length, amount);
  console.log("[dca] flow rate:", flowRateInWei.toString());

  // start streaming the tokens from the user to the dca superapp contract
  try {
    const contractAddr = getDcaPoolContractAddr(chainId, sourceToken, targetToken);
    console.log("[dca] super app", contractAddr);
    console.log("[dca] source token address", getTokenAddress(chainId, sourceToken));

    const forwarder = await getCFAv1ForwarderContract(chainId, signer);
    console.log("got the forwarder");

    let tx = await forwarder.createFlow(
      getTokenAddress(chainId, sourceToken),
      account,
      contractAddr,
      flowRateInWei,
      []
    );
    console.log("[dca] tx created", tx);

    return tx;
  } catch (error) {
    console.error("[dca] error", error);
    throw error;
  }
}

async function stopDCA(chainId, signer, account, sourceToken, contractAddr) {
  try {
    const forwarder = await getCFAv1ForwarderContract(chainId, signer);
    return await forwarder.deleteFlow(getTokenAddress(chainId, sourceToken), account, contractAddr, []);
  } catch (error) {
    console.error("[stop stream] error", error);
    throw error;
  }
}

export { computeFlowrate, calculateEscrowAmount, calculateDailyAmount, startDCA, stopDCA };
